import React, { useState } from "react";
import { resetPassword } from 'aws-amplify/auth';

const ForgotPasswordFlow = () => {
  const [step, setStep] = useState(1); // Controla el paso del flujo
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  // Validaciones simples
  const validateInput = () => {
    if (!username || !email) {
      setMessage("El nombre de usuario y el correo son obligatorios.");
      return false;
    }
    return true;
  };

  // Paso 1: Solicitar código de recuperación
  const handleSendCode = async () => {
    if (!validateInput()) return;
    try {
      await resetPassword(username);
      setMessage("Se ha enviado un código de confirmación a tu correo.");
      setStep(2);
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    }
  };

  // Paso 2: Confirmar código y establecer nueva contraseña
  const handleResetPassword = async () => {
    if (!code || !newPassword) {
      setMessage("El código de confirmación y la nueva contraseña son obligatorios.");
      return;
    }
    try {
      await resetPassword(username, code, newPassword);
      setMessage("¡Contraseña cambiada con éxito! Ahora puedes iniciar sesión.");
      setStep(1); // Reinicia el flujo
      setUsername("");
      setEmail("");
      setCode("");
      setNewPassword("");
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "auto", textAlign: "center" }}>
      <h2>Recuperar Contraseña</h2>
      {message && <p style={{ color: "red" }}>{message}</p>}
      {step === 1 && (
        <div>
          <input
            type="text"
            placeholder="Nombre de usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ marginBottom: "10px", width: "100%", padding: "8px" }}
          />
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginBottom: "10px", width: "100%", padding: "8px" }}
          />
          <button onClick={handleSendCode} style={{ width: "100%", padding: "10px" }}>
            Enviar Código
          </button>
        </div>
      )}
      {step === 2 && (
        <div>
          <input
            type="text"
            placeholder="Código de confirmación"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            style={{ marginBottom: "10px", width: "100%", padding: "8px" }}
          />
          <input
            type="password"
            placeholder="Nueva contraseña"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ marginBottom: "10px", width: "100%", padding: "8px" }}
          />
          <button onClick={handleResetPassword} style={{ width: "100%", padding: "10px" }}>
            Restablecer Contraseña
          </button>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordFlow;
